// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1NIZs","header":"PatientBlock_header__PoSjK","label":"PatientBlock_label__N1GBc","option":"PatientBlock_option__1WBwz"};